<template>
    <div class="map-region-section">
        <div class="container">
            <div class="row">
                <div class="col-md-6" data-aos="zoom-in">
                    <div class="info">
                        <h3 class="title">
                            Busque por região geográfica e cruze com mais de 50 opções de filtros
                        </h3>

                        <div class="content">
                            Se inscreva na plataforma e faça buscas por região geográfica e mais de 50 opções de filtros.<br><br>
                            Descubra, por exemplo, quem são os doadores do ecossistema, filtre iniciativas de todo o Brasil por temáticas ou ODSs (Objetivos do Desenvolvimento Sustentável), dentre várias outras possibilidades.
                        </div>

                        <div class="footer-buttons">
                            <button class="btn btn-warning" @click="setShowMap(true), scrollBehavior()">
                                Acessar mapa
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-6" data-aos="zoom-in">
                    <BrazilMapPP :states="getStates" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import BrazilMapPP from '@/ui/brazil-map-pp/BrazilMapPP'

export default {
    name: 'MapRegionSection',
    components: { BrazilMapPP },
    props: {
        states: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getStates() {
            return this.states
        }
    },
    methods: {
        ...mapActions(['setShowMap']),
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-map')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style scope src="./MapRegionSection-light-theme.css"></style>
<style scope src="./MapRegionSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/map-region-section/MapRegionSection.vue